<template>
  <div class="m_publication">
    <div class="m_publication--publi" @click="openPubli">
      <transition name="fade">
        <PagedPublicationTemplate
          v-if="show_publis"
          v-show="!$root.current_publication_opened"
          :publication="publication"
          :mode="'stacked'"
          :zoom="0.4"
          :show_page="1"
        />
      </transition>
    </div>
    <div class="m_publication--text">
      <div class="m_publication--name" @click="openPubli">
        {{ publication.name }}
      </div>

      <div class="m_publication--meta">
        créé
        <span v-if="publi_authors && publi_authors.length > 0"
          >par {{ $root.formatListToHuman(publi_authors) }}</span
        >
        le {{ $root.formatDateToHuman(publication.date_created) }}
      </div>

      <div v-if="readKeywords(publication.keywords).length > 0">
        <!-- <span
          v-html="
            readKeywords(publication.keywords).length === 1
              ? 'Mot-clé&nbsp;'
              : 'Mots-clés&nbsp;'
          "
        />-->
        <span
          v-for="(kw, index) in readKeywords(publication.keywords)"
          :key="index"
        >
          <button type="button" disabled>
            <template v-if="index > 0">•</template>
            {{ kw }}
          </button>
        </span>
      </div>

      <div class="m_publication--meta _number_of_replies">
        <div>
          <img
            :src="`${$root.publicPath}pictos/icone_pasApas.svg`"
            width="40"
            height="40"
          />
          <span
            >{{
              $root.getPublications({
                template: "story",
                follows_model: "documentation-pas-a-pas",
                keyword: publication.slugFolderName,
              }).length
            }}
          </span>
        </div>
        <div>
          <img
            :src="`${$root.publicPath}pictos/icone_Recit-libre.svg`"
            width="40"
            height="40"
          />
          <span
            >{{
              $root.getPublications({
                template: "story",
                follows_model: "documentation-libre",
                keyword: publication.slugFolderName,
              }).length
            }}
          </span>
        </div>
      </div>

      <div class="m_publication--buttons">
        <button type="button" @click="openPubli">
          <svg
            version="1.1"
            class="m_project--presentation--buttons--openButton--icon inline-svg"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            width="46.3px"
            height="46.3px"
            viewBox="0 0 46.3 46.3"
            style="enable-background: new 0 0 46.3 46.3"
            xml:space="preserve"
          >
            <path
              class="st0"
              style="fill: currentColor"
              d="M38.1,29.1L37.8,23c-0.1-3.7-0.1-6.7,0.6-9.7l-33,33L0,40.9L32.9,7.9c-2.9,0.6-6,0.6-9.6,0.5l-6.2-0.3L17.8,0
		l27.1,1.4l1.4,27.1L38.1,29.1z"
            />
          </svg>
        </button>
        <!-- <a
          class="button"
          target="_blank"
          v-if="publication.is_model"
          :href="link_to_reply"
          >répondre</a
        > -->
      </div>
    </div>
  </div>
</template>
<script>
import PagedPublicationTemplate from "./PagedPublicationTemplate.vue";
export default {
  props: {
    publication: Object,
  },
  components: {
    PagedPublicationTemplate,
  },
  data() {
    return {
      show_publis: false,
    };
  },
  created() {},
  mounted() {
    setTimeout(() => {
      this.show_publis = true;
    }, 100);
  },
  beforeDestroy() {},
  watch: {},
  computed: {
    publi_authors() {
      if (!this.publication.authors) return false;
      const slugs = this.publication.authors.reduce((acc, a) => {
        if (a.slugFolderName) acc.push(a.slugFolderName);
        return acc;
      }, []);

      return slugs.reduce((acc, s) => {
        if (
          this.$root.hasOwnProperty("authors") &&
          this.$root.authors.hasOwnProperty(s)
        ) {
          acc.push(this.$root.authors[s].name);
        }
        return acc;
      }, []);
    },
    link_to_reply() {
      return (
        this.$root.dodoc_url +
        "_publications/reply/" +
        this.publication.slugFolderName
      );
    },
  },
  methods: {
    readKeywords(kw) {
      if (!kw) return [];
      return kw.map((k) => k.title);
    },
    openPubli() {
      this.$root.state.modal.current_publication_slug = this.publication.slugFolderName;
    },
  },
};
</script>
<style lang="scss" scoped>
.m_publication {
  position: relative;
  background-color: #f9f9f9;
  background-color: white;
  border-radius: 4px;

  &:hover {
    ::v-deep .m_pagedPublicationTemplate {
      transform: translate(0, calc(-1 * var(--spacing)));
    }
  }
}

.m_publication--publi {
  padding: calc(var(--spacing) * 3) calc(var(--spacing) * 2);
  height: 300px;
  overflow: hidden;

  border: 2px solid var(--color-gray);
  border-bottom: 2px solid var(--logo-blue);
  // background-color: #333;
  // background-color: white;
  background-color: var(--color-gray);

  ::v-deep .m_pagedPublicationTemplate {
    transition: all 0.4s cubic-bezier(0.19, 1, 0.22, 1);
  }
}

.m_publication--text {
  padding: 0 var(--spacing) var(--spacing) 0;

  > * {
    max-width: 44ch;
    margin: calc(var(--spacing) / 3) 0;
  }
}

.m_publication--authors {
  // // color: var(--logo-blue_lighter);
  // font-size: 0.8rem;
}

.m_publication--name {
  font-weight: 700;
  font-size: 1.4rem;
}

.m_publication--meta {
  font-family: "Alegreya", Georgia, serif;
  max-width: 54ch;
  // font-size: 0.9rem;
}

.m_publication--buttons {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 10;
  margin: 0;
  margin: calc(var(--spacing) / 3);

  button {
    margin: calc(var(--spacing) / 3);
    svg {
      width: 1em;
      height: 1em;
    }
  }
}

.m_publication--publi,
.m_publication--name,
.m_publication--buttons button {
  cursor: pointer;
}

._number_of_replies {
  display: flex;
  flex-flow: row wrap;

  > * {
    position: relative;

    span {
      position: absolute;
      bottom: 0;
      right: 0;
      background-color: var(--color-green);
      min-width: 1em;
      height: 1em;
      color: white;
      display: flex;
      align-items: center;
      text-align: center;
      justify-content: center;
      line-height: 1;
      border-radius: 1em;
      padding-bottom: 2px;
    }
  }
}
</style>
